export default __webpack_public_path__ + "static/media/mode-2044.a54b184d.svg";